// extracted by mini-css-extract-plugin
export default {"container":"components-CardGroup-styles-module__container--ysd9i"};